import { Box, CircularProgress, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import React from 'react';

interface LoadingProps {
  message: string;
  caption?: string;
}
export const useLoadingToast = () => {
  const toastId = 'loading-toast';
  const close = React.useCallback(() => toast.dismiss(toastId), []);

  const open = React.useCallback((props: LoadingProps) => {
    const { message, caption } = props;

    const Msg = () => {
      return (
        <Box>
          <Typography variant="body2">{message}</Typography>
          {caption && <Typography variant="caption">{caption}</Typography>}
        </Box>
      );
    };

    toast.success(<Msg />, {
      toastId,
      autoClose: false,
      icon: () => (
        <Box sx={{ width: 20, height: 20 }}>
          <CircularProgress size={18} sx={{ color: 'white' }} />
        </Box>
      ),
    });
  }, []);

  return React.useMemo(
    () => ({
      open,
      close,
    }),
    [open, close],
  );
};
